import { ReactComponent as ServiceProducts } from '../../../assets/svg/services-products.svg';
import Container from '../../../components/container';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import soldaX from '../../../assets/images/services/solda-x.png';
import usinagemX from '../../../assets/images/services/usinagem-x.png';
import cabecaPolimentoX from '../../../assets/images/services/cabeca-polimento-x.png';
import mancalRetificaX from '../../../assets/images/services/mancal-retifica-x.png';
import { routes } from '../../../helpers/routes.helper';

interface IServicesAndProducts {
	id: number;
	title: string;
	description: string;
	type?: 'product' | 'service';
	image: string;
}

export default function ServicesProducts() {
	const servicesAndProducts: IServicesAndProducts[] = [
		{
			id: 1,
			title: 'Usinagem',
			type: 'service',
			description: 'A usinagem é um processo de fabricação que utiliza ferramentas de corte para remover material de uma peça bruta, moldando-a de acordo com o projeto desejado. ',
			image: usinagemX,
		},
		{
			id: 2,
			title: 'Cabeças de Polimento',
			type: 'product',
			description: 'As cabeças de polimento utilizadas no processo de acabamento de porcelanatos desempenham um papel crucial na obtenção de superfícies de alta qualidade.',
			image: cabecaPolimentoX,
		},
		{
			id: 3,
			title: 'Solda',
			type: 'service',
			description: 'A solda é um processo que une materiais, principalmente metais, utilizando material de adição fundido. Entre os principais tipos estão solda a fogo, eletrodo, MIG e TIG.',
			image: soldaX,
		},
		{
			id: 4,
			title: 'Mancal de Retífica',
			type: 'product',
			description: 'O mancal de retífica cerâmica é um componente fundamental utilizado em máquinas de retífica para apoiar, guiar e estabilizar o eixo ou a ferramenta de corte durante o processo de usinagem e acabamento de peças cerâmicas.',
			image: mancalRetificaX,
		}
	]

	const renderWeb = (
		<div className={'flex flex-col gap-4'}>
			<div className={'grid grid-cols-4 gap-6'}>
				{servicesAndProducts.map((item, key) => (
					<div key={`${key}`}>
						{item.type === 'service' && (
							<div className={'w-full flex'}>
								<ServiceProducts className={'h-20'}/>
							</div>
						)}
						{item.type === 'product' && (
							<div className={'w-full flex'}>
								<FontAwesomeIcon icon={faCog} size={'5x'} className={'text-accent'}/>
							</div>
						)}
					</div>
				))}
			</div>

			<div className={'grid grid-cols-4 gap-6'}>
				{servicesAndProducts.map((item, key) => (
					<div key={`${key}`} className={'row-span-1 flex flex-col justify-between'}>
						<p>{item.title}</p>
						<p className={'roboto py-4'}>
							{item.description}
						</p>
						<a href={item.type === 'product' ? routes.products : routes.services}
							className={'text-accent'}>
							Saiba mais
						</a>
					</div>
				))}
			</div>

			<div className={'grid grid-cols-4 gap-6'}>
				{servicesAndProducts.map((item, key) => (
					<div key={`${key}`} className={'row-span-1'}>
						<img className={'rounded'} src={item.image} alt={item.title}/>
					</div>
				))}
			</div>
		</div>
	);

	const renderMobile = (
		<div>
			<div className={'flex flex-col items-center py-4 space-y-12'}>
				{servicesAndProducts.map((item, key) => (
					<div key={`${key}`} className={'flex flex-col items-start gap-y-8'}>
						<div className={'h-20'}>
							{item.type === 'service' && (
								<div className={'w-full flex'}>
									<ServiceProducts className={'h-20'}/>
								</div>
							)}
							{item.type === 'product' && (
								<div className={'w-full flex'}>
									<FontAwesomeIcon icon={faCog} size={'5x'} className={'text-accent'}/>
								</div>
							)}
						</div>

						<div className={'line-clamp-6 '}>
							<p>{item.title}</p>
							<p className={'roboto py-4'}>
								{item.description}
							</p>
							<a href={item.type === 'product' ? routes.products : routes.services}
								className={'text-accent'}>
								Saiba mais
							</a>
						</div>
						<div>
							<img className={'rounded'} src={item.image} alt={item.title}/>
						</div>
					</div>
				))}
			</div>
		</div>
	);

	return (
		<Container className={'bg-neutral w-full text-neutral-content'}>
			<div className={'flex flex-col justify-center items-center '}>
				<p className={'text-3xl text-center'}>Serviços e Produtos</p>
				<div className={'bg-secondary border-2 border-secondary w-64 my-4'}></div>
			</div>

			<div className={'hidden sm:block'}>{renderWeb}</div>
			<div className={'block sm:hidden'}>{renderMobile}</div>
		</Container>
	);
}